// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this rule to remove outline on all elements */
* {
    outline: none !important;
}

.btn-register{
  background-color: #F3903F; /* Orange */
  color: white; /* White text */
  font-weight: 600;
  font-size: 16px;
  padding: 5px 5px;
    size: 16px;
    height: 40px;
  border-radius: 5px;
  border: none;
  transition:  0.3s ease, transform 0.2s ease;
}
.logo{
    height:100%;
    width:90%;
   
}
.logoimag{
    width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/pages/register/register.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;IACI,wBAAwB;AAC5B;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,YAAY,EAAE,eAAe;EAC7B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;IACd,UAAU;IACV,YAAY;EACd,kBAAkB;EAClB,YAAY;EACZ,2CAA2C;AAC7C;AACA;IACI,WAAW;IACX,SAAS;;AAEb;AACA;IACI,UAAU;AACd","sourcesContent":["/* Add this rule to remove outline on all elements */\r\n* {\r\n    outline: none !important;\r\n}\r\n\r\n.btn-register{\r\n  background-color: #F3903F; /* Orange */\r\n  color: white; /* White text */\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  padding: 5px 5px;\r\n    size: 16px;\r\n    height: 40px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  transition:  0.3s ease, transform 0.2s ease;\r\n}\r\n.logo{\r\n    height:100%;\r\n    width:90%;\r\n   \r\n}\r\n.logoimag{\r\n    width: 90%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
